import { Component, inject, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs';
import { PackageStatusDetails } from 'src/app/core/models/package-status-details.model';
import { PackageStatusService } from 'src/app/core/services/package-status/package-status.service';
import { PackageStatusDetailsComponent } from '../../../modal/package-status-details/package-status-details.component';

@Component({
  selector: 'app-table-tracking-number-cell',
  templateUrl: './table-tracking-number-cell.component.html',
  styleUrls: ['./table-tracking-number-cell.component.scss'],
  imports: [],
})
export class TableTrackingNumberCellComponent {
  private readonly _packageStatusService = inject(PackageStatusService);
  @Input() trackingNumber!: string;

  constructor(private readonly matDialog: MatDialog) {}

  openPackageDetails() {
    this._packageStatusService
      .getPackageStatus(this.trackingNumber)
      .pipe(take(1))
      .subscribe((packageStatusResponse) => {
        const packageStatus = packageStatusResponse?.response || null;
        if (packageStatus) {
          const packageStatusDetails: PackageStatusDetails = {
            trackingNumber: packageStatus.tracknum,
            reason: packageStatus.smartValues?.reason || '',
            equipmentNumber: packageStatus.uld,
            scanTime: packageStatus.scanTime,
            destination: packageStatus.smartValues?.destCountry || '',
            sortCode:
              packageStatus.smartValues?.code ||
              packageStatus.smartValues?.intlsortCode ||
              '',
            equipmentType: packageStatus.uldType,
            movement: packageStatus.movement,
            userId: packageStatus.userName,
            loadChart: packageStatus.loadChart,
            status: packageStatus.status,
            sortDate: packageStatus.smartValues?.sortDate || '',
            loadKey: packageStatus.loadKey,
            flex: packageStatus.flex,
            childLoad: packageStatus.smartValues?.childLoadChart || '',
          };
          this.openPackageStatusPopup(
            packageStatusDetails,
            !!packageStatus?.smartValues || false,
          );
        }
      });
  }

  openPackageStatusPopup(
    packageStatusDetails: PackageStatusDetails,
    isSmartValue: boolean,
  ) {
    this.matDialog.open(PackageStatusDetailsComponent, {
      width: '50rem',
      height: isSmartValue ? '23.94rem' : '20rem',
      disableClose: true,
      data: {
        trackingNumber: this.trackingNumber,
        packageStatusDetails,
        isSmartValue,
      },
    });
  }
}
